import React from 'react';
import { Flex, Box } from 'grid-styled';

import Section from '../../uic/Section';
import { List, Row } from '../../uic/list';
import BusyOverlay from '../../uic/BusyOverlay';
import Button from '../../uic/Button';
import session from '../../session';
import ValueRow from '../../uic/ValueRow';
import Input from './Input';
import Checkbox from './Checkbox';

class Relay extends React.Component {
    state = {
        busy: false,
        editing: false,
        formValid: true,
        current: {
            disabled: 1,
            local_mount: '',
            port: '',
            relay_shoutcast_metadata: '',
            remote_mount: ''
        },
        form: {
            disabled: 1,
            local_mount: '',
            port: '',
            relay_shoutcast_metadata: '',
            remote_mount: ''
        }
    };

    load = async () => {
        const res = await session.rpc('call', [
            '',
            'uci',
            'get',
            {
                config: 'icecast',
                section: 'relay'
            }
        ]);
        const {
            disabled,
            server,
            local_mount,
            port,
            relay_username,
            relay_password,
            relay_shoutcast_metadata,
            remote_mount
        } = res[1].values;
        const current = {
            disabled,
            local_mount,
            server,
            port,
            relay_username,
            relay_password,
            relay_shoutcast_metadata,
            remote_mount
        };
        this.setState({
            current,
            form: current
        });
    };

    componentDidMount() {
        this.load();
    }

    onEdit = () => {
        const { current } = this.state;
        this.setState({ editing: true, form: { ...current } });
    };
    onCancel = () => this.setState({ editing: false });

    onSave = async () => {
        const { form } = this.state;
        this.setState({ busy: true });
        await session.rpc('call', [
            '',
            'uci',
            'set',
            {
                config: 'icecast',
                section: 'relay',
                values: form
            }
        ]);
        await session.rpc('call', ['', 'uci', 'commit', {}]);
        await this.load();
        this.setState({ editing: false, busy: false });
    };

    renderReadOnly = () => {
        const {
            disabled,
            local_mount,
            port,
            relay_shoutcast_metadata,
            remote_mount,
            relay_username,
            server
        } = this.state.current;
        return (
            <React.Fragment>
                <List>
                    <ValueRow
                        label="Enabled"
                        value={disabled === '0' ? 'Yes' : 'No'}
                    />
                    <ValueRow label="Remote Server" value={server} />
                    <ValueRow label="Remote Port" value={port} />
                    <ValueRow label="Remote Mount" value={remote_mount} />
                    <ValueRow label="Local Mount" value={local_mount} />
                    <ValueRow label="Username" value={relay_username} />
                    <ValueRow
                        label="Relay Shoutcast Metadata"
                        value={relay_shoutcast_metadata === '0' ? 'No' : 'Yes'}
                    />
                    <ValueRow label="" value="" />
                    <Row>
                        <Box w={1 / 2}>Listen online</Box>
                        <Flex w={1 / 2}>
                            <audio
                                controls
                                src={`http://${
                                    window.location.hostname
                                }:8000${local_mount}`}
                                type="audio/mpeg"
                            />
                        </Flex>
                    </Row>
                </List>
                <Flex justifyContent="flex-end" mt={5}>
                    <Button onClick={this.onEdit} icon="edit">
                        Edit
                    </Button>
                </Flex>
            </React.Fragment>
        );
    };

    onChange = form => this.setState({ form });

    renderEdit = () => {
        const { formValid, form } = this.state;
        return (
            <React.Fragment>
                <List>
                    <ValueRow label="Enabled">
                        <Checkbox
                            model={form}
                            negate
                            field="disabled"
                            onChange={this.onChange}
                        />
                    </ValueRow>
                    <ValueRow label="Remote Server">
                        <Input
                            model={form}
                            field="server"
                            onChange={this.onChange}
                        />
                    </ValueRow>
                    <ValueRow label="Remote Port">
                        <Input
                            type="number"
                            model={form}
                            field="port"
                            onChange={this.onChange}
                        />
                    </ValueRow>
                    <ValueRow label="Remote Mount">
                        <Input
                            model={form}
                            field="remote_mount"
                            onChange={this.onChange}
                        />
                    </ValueRow>
                    <ValueRow label="Local Mount">
                        <Input
                            model={form}
                            field="local_mount"
                            onChange={this.onChange}
                        />
                    </ValueRow>
                    <ValueRow label="Username">
                        <Input
                            model={form}
                            field="relay_username"
                            onChange={this.onChange}
                        />
                    </ValueRow>
                    <ValueRow label="Password">
                        <Input
                            model={form}
                            field="relay_password"
                            onChange={this.onChange}
                        />
                    </ValueRow>
                    <ValueRow label="Relay Shoutcast Metadata">
                        <Checkbox
                            model={form}
                            field="relay_shoutcast_metadata"
                            onChange={this.onChange}
                        />
                    </ValueRow>
                </List>
                <Flex justifyContent="flex-end">
                    <Button icon="close" onClick={this.onCancel}>
                        Cancel
                    </Button>

                    <Button
                        icon="check"
                        onClick={this.onSave}
                        disabled={!formValid}
                        disabledStyle={{ color: 'redRed' }}
                    >
                        Save
                    </Button>
                </Flex>
            </React.Fragment>
        );
    };

    render() {
        const { editing, busy } = this.state;

        return (
            <Flex flexDirection={['column', 'row']}>
                <Section title="Relay Settings">
                    {editing ? this.renderEdit() : this.renderReadOnly()}
                </Section>
                {busy && <BusyOverlay />}

                <Section title="Help">
                    <p>
                        <b>Enabled: </b>
                        Is stream relaying active or not.<br />
                        Default: No
                        <br />
                    </p>
                    <p>
                        <b>Remote Server: </b>
                        IP address or domain name of the Server whose mountpoint
                        will be relayed.<br />
                        Default: (empty)
                    </p>
                    <p>
                        <b>Remote Port: </b>
                        Port on the Remote Server on which the stream is
                        accessible.<br /> Default: 8000
                    </p>
                    <p>
                        <b>Remote Mount: </b>
                        Name of the Remote Mount point which will be relayed.<br />
                        Default: /input-stream
                    </p>
                    <p>
                        <b>Local Mount: </b>
                        Name of the mount point under which the Relayed Stream
                        will be accessible.<br /> Set your Local Mount to
                        "authenticate" if you wish to implement listener
                        authentication. For more information, see the
                        Application User Manual.
                        <br />Default: /relay-stream
                    </p>
                    <p>
                        <b>Username: </b>
                        If authentication is active, username to connect to
                        Remote Mountpoint. <br />Default: (empty)
                    </p>
                    <p>
                        <b>Password: </b>
                        If authentication is active, password to connect to
                        Remote Mountpoint. <br />Default: (empty)
                    </p>
                    <p>
                        <b>Relay Shoutcast Metadata: </b>
                        In addition to relaying the stream's content, relay the
                        metadata too. <br />Default: No
                    </p>
                </Section>
            </Flex>
        );
    }
}

export default Relay;



// WEBPACK FOOTER //
// ./src/pages/Relay/RelayPage.js